"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetImpressionAndBDLCheckRequestToJSON = exports.GetImpressionAndBDLCheckRequestFromJSONTyped = exports.GetImpressionAndBDLCheckRequestFromJSON = exports.instanceOfGetImpressionAndBDLCheckRequest = void 0;
var runtime_1 = require("../runtime");
var AudienceSizeRequest_1 = require("./AudienceSizeRequest");
/**
 * Check if a given object implements the GetImpressionAndBDLCheckRequest interface.
 */
function instanceOfGetImpressionAndBDLCheckRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetImpressionAndBDLCheckRequest = instanceOfGetImpressionAndBDLCheckRequest;
function GetImpressionAndBDLCheckRequestFromJSON(json) {
    return GetImpressionAndBDLCheckRequestFromJSONTyped(json, false);
}
exports.GetImpressionAndBDLCheckRequestFromJSON = GetImpressionAndBDLCheckRequestFromJSON;
function GetImpressionAndBDLCheckRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'holdoutReductionPercentage': !(0, runtime_1.exists)(json, 'holdout_reduction_percentage') ? undefined : json['holdout_reduction_percentage'],
        'adSetRequests': !(0, runtime_1.exists)(json, 'ad_set_requests') ? undefined : (0, AudienceSizeRequest_1.AudienceSizeRequestFromJSON)(json['ad_set_requests']),
    };
}
exports.GetImpressionAndBDLCheckRequestFromJSONTyped = GetImpressionAndBDLCheckRequestFromJSONTyped;
function GetImpressionAndBDLCheckRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'holdout_reduction_percentage': value.holdoutReductionPercentage,
        'ad_set_requests': (0, AudienceSizeRequest_1.AudienceSizeRequestToJSON)(value.adSetRequests),
    };
}
exports.GetImpressionAndBDLCheckRequestToJSON = GetImpressionAndBDLCheckRequestToJSON;
